

exports.__esModule = true;
exports.$xoPageAddFiPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-wallet-components/src/add-card/directive');

require('xo-validation/dist/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-page-components/src/value-props/directive');

require('xo-models/src/checkout/index');

require('xo-models/src/fi/lib/fiMessages');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddFiPageComponent = exports.$xoPageAddFiPageComponent = _squid.$Component.extend('$xoPageAddFiPageComponent', {
    tag: 'xo-page-add-fi-page',
    template: _template2['default'],
    scope: {
        logout: '='
    },
    controller: function controller($scope, $rootScope, $util, $AuthModel, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $fiMessages, $logger) {
        // eslint-disable-line no-shadow
        $scope.token = $rootScope.token;
        $scope.locale = $locale;

        $scope.billingaddressupdated = {
            value: false
        };

        $scope.hideparenthead = {
            toggle: false
        };

        $scope.title = $locale.content.get('addCard.addACard');

        $scope.callbacks = {
            finish: function finish() {
                $state.go('checkout.review');
            },
            done: function done() {
                $state.go('checkout.review');
            }

        };

        var models = {};

        $populate($scope, {
            auth: $AuthModel.instance(),
            payee: $CheckoutPayeeModel.instance($scope.token)
        }).then(function () {

            $scope.logout = function () {
                $logger.info('not_you_logout');
                $scope.auth.action('logout').then(function () {
                    $state.go('checkout.login');
                });
            };

            $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp';
            $populate(models, {
                checkoutSession: $CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false) || $fiMessages.errorMsg($scope.payee.isGambling());

                if (message.msg) {
                    $scope.pageLevel = $scope.pageLevel || {};
                    $scope.pageLevel.message = {
                        type: 'info',
                        msgs: [message.msg]
                    };
                }
            });
        });
    }
});

angular.value("$xoPageAddFiPageComponent", $xoPageAddFiPageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-fi/directive.js
// module id = ./pages/xo-add-fi/directive.js
// module chunks = 1